<template>
	<div class="divContainer">
		<div class="divContainer1">
			<span class="previewtext">效果预览</span>
			<div :class="bindClass">
				<img class="phonestyle1" src="/img/phone.png" alt="">
				<div class="phonestyle2" v-if="useimgPrese==1">
						<img  v-if="usepagedata.content_html.lists.length>0" :src="$baseFunc.getAliOssAuthKey(item.url)" alt="" v-for="(item,index) in usepagedata.content_html.lists">
						<img v-else :src="item" alt="" v-for="(item,index) in imglist">
				</div>
				<div v-else>
					<a-carousel class="carouselcontainer" autoplay dotsClass="dotdot">
							<img v-if="usepagedata.content_html.lists.length>0" :src="$baseFunc.getAliOssAuthKey(item.url)" alt="" v-for="(item,index) in usepagedata.content_html.lists">
							<img v-else :src="item" alt="" v-for="(item,index) in imglist">
					</a-carousel>
				</div>
			</div>
		</div>
		<div class="divContainer2" style="padding-top: 120px;">
			<div class="divContainer21">
				<span class="setTitle">图片样式设置</span>
				<a-radio-group v-model:value="useimgStyle">
					<a-radio :value="1">留白</a-radio>
					<a-radio :value="2">撑满</a-radio>
					<a-radio :value="3">置顶撑满</a-radio>
				</a-radio-group>
			</div>
			
			<div class="divContainer21">
				<span class="setTitle">图片展示设置</span>
				<a-radio-group v-model:value="useimgPrese">
					<a-radio :value="1">平铺</a-radio>
					<a-radio :value="2">轮播</a-radio>
					<a-radio :value="3">轮播切片</a-radio>
				</a-radio-group>
			</div>
			<p class="tips1" v-if="useimgPrese==2">建议9张内，以图片中最大的长宽比例显示</p>
			<p class="tips1" v-if="useimgPrese==3">建议9张内，以第一张图片的长宽展示，建议所有图片长宽一致</p>
			<p @click="setok" class="tips">提示:H5打开方式支持内容中的二维码图片长按识别，小程序打开方式不支持。</p>
		</div>
	</div>
</template>

<script>
	import { defineComponent, ref ,watch,reactive} from 'vue';
	import {
		ExclamationCircleOutlined
	} from '@ant-design/icons-vue';
	import baseFunc from '../config/base_func.js';
	export default defineComponent({
		name: 'imgSet',
		props:{
			imgStyle:Number,
			imgPrese:Number,
			pagedata:Object,
		},
		components: {
			ExclamationCircleOutlined
		},
		setup(props,context) {
			let useimgStyle=ref(props.imgStyle);
			let useimgPrese=ref(props.imgPrese);
			let bindClass=ref('phonestyle bindClass1');
			let imglist=reactive(['/img/test.png','/img/test.png','/img/test.png'])
			let usepagedata=reactive(props.pagedata);
			const setok=(e)=>{
			}
			//图片样式
			watch(useimgStyle,(newval,oldval)=>{
				bindClass.value='phonestyle bindClass'+newval;
				context.emit('setimgStyle',newval)
			})
			//图片展示方式
			watch(useimgPrese,(newval,oldval)=>{
				context.emit('setimgPrese',newval)
			})
			
			return {
				useimgStyle,
				setok,
				useimgPrese,
				bindClass,
				usepagedata,
				imglist
			};
		},
		
	});
	
</script>

<style scoped>
	
	.carouselcontainer img{
		max-height: 270px;
		object-fit: contain;
	}
	.ant-carousel :deep(.slick-dots li button) {
	  width:6px;
	  height: 6px;
	  background-color: #fff;
	  border-radius: 50%;
	  opacity: 1;
	}
	.ant-carousel :deep(.slick-active button) {
		  width:6px !important;
		  height: 6px !important;
		  background-color: #1890ff !important;
	}
	.ant-carousel :deep(.slick-slide) {
	  text-align: center;
	  overflow: hidden;
	  font-size: 0;
	}
	.divContainer21{
		height: 50px;
		display: flex;
		align-items: center;
	}
	.phonestyle2 img{
		width: 100%;
		height: auto;
	}
	.phonestyle2{
		font-size: 0;
		height:100%;
		height:270px;
		overflow-y:scroll;
		overflow-x:hidden;
		transition: all .3s;
	}
	.phonestyle2::-webkit-scrollbar{
		display:none
	}
	.bindClass1{
		padding:40px 10px 0;
		
	}
	.bindClass2{
		padding:40px 0 0;
	}
	.bindClass3{
		padding:0;
	}
	.bindClass3 .phonestyle2{
		height:310px;
	}
	.tips1{
		font-size:12px;
		color: #999;
	}
	.tips{
		font-size:12px;
		color: #999;
		position: absolute;
		bottom: 24px;
		left: 24px;
	}
	.phonestyle1{
		position: absolute;
		left: 0;
		top: 0;
		width: 180px;
		height: 30px;
		z-index:9999;
	}
	.phonestyle{
		position: relative;
		width: 180px;
		font-size: 0;
		height: 310px;
		background-color: #fff;
		transition: all .3s; 
	}
	.previewtext{
		line-height: 50px;
		height: 50px;
		display: inline-block;
		width: 180px;
		color: rgba(0, 0, 0, .6);
	}
	.setTips {
		color: #ff8a00;
		margin-bottom: 0;
		line-height: 30px;
		margin-top: 55px;
	}

	.setTips :deep(.anticon) {
		font-size: 14px;
	}

	.setDesc {
		color: rgba(0, 0, 0, .6);
		margin-left: 40px;
	}

	.radioitem {
		width: 88px;
		margin-right: 8px;
		font-weight: bold;
		color: rgba(0, 0, 0, .6);
	}

	.setTitle {
		font-size: 14px;
		color: #000;
		display: inline-block;
		width: 120px;
		font-weight: bold;
	}

	.divContainer1 {
		width: 260px;
		height: 100%;
		float: left;
		background-color: #f6f8f9;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		align-items: flex-start;
		align-content: flex-start;
	}
	.divContainer2{
		margin-left: 260px;
		position: relative;
		height: 100%;
		padding: 24px;
	}
	.divContainer {
		max-width: 800px;
		width: 800px;
		height: 392px;
	}
</style>
